export const GLOBAL_REQ_CANCEL = 'GLOBAL_REQ_CANCEL';
export const LOG_EVENT = 'LOG_EVENT';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';

// Loading Actions
export const UI_LOADING_START = 'UI_LOADING_START';
export const UI_LOADING_END = 'UI_LOADING_END';

//Event actions
export const GET_EVENT = 'GET_EVENT';
export const GET_EVENT_CREW = 'GET_EVENT_CREW';

//Team actions
export const GET_TEAM = 'GET_TEAM';

//Broadcast
export const SYNC_OVERLAYS = 'SYNC_OVERLAYS';
export const GET_BROADCAST = 'GET_BROADCAST';
export const UPDATE_OVERLAYS = 'UPDATE_OVERLAYS';
export const SYNC_BACKGROUNDS = 'SYNC_BACKGROUNDS';
export const UPDATE_BACKGROUNDS = 'UPDATE_BACKGROUNDS';
export const BROADCAST_SET_AUDIO_DEVICE = 'BROADCAST_SET_AUDIO_DEVICE';
export const BROADCAST_SET_VIDEO_DEVICE = 'BROADCAST_SET_VIDEO_DEVICE';
export const BROADCAST_SET_AUDIO_OUTPUT_DEVICE =
  'BROADCAST_SET_AUDIO_OUTPUT_DEVICE';
export const BROADCAST_SET_ATTENDEE_TILE = 'BROADCAST_SET_ATTENDEE_TILE';
export const BROADCAST_SET_MIXER_TILE = 'BROADCAST_SET_MIXER_TILE';
export const BROADCAST_SET_MIXER_ATTENDEE = 'BROADCAST_SET_MIXER_ATTENDEE';
export const BROADCAST_CREATE_MEETING = 'BROADCAST_CREATE_MEETING';
export const BROADCAST_RESET_SOURCES = 'BROADCAST_RESET_SOURCES';
export const BROADCAST_CREATE_PRESENTERS = 'BROADCAST_CREATE_PRESENTERS';
export const BROADCAST_DELETE_PRESENTERS = 'BROADCAST_DELETE_PRESENTERS';
export const BROADCAST_CREATE_ATTENDEE = 'BROADCAST_CREATE_ATTENDEE';
export const BROADCAST_MIXER_END_TASK = 'BROADCAST_MIXER_END_TASK';
export const BROADCAST_DELETE_ATTENDEE = 'BROADCAST_DELETE_ATTENDEE';
export const BROADCAST_SET_ATTENDEE_PRESENCE =
  'BROADCAST_SET_ATTENDEE_PRESENCE';
export const BROADCAST_SET_ATTENDEE_NAME = 'BROADCAST_SET_ATTENDEE_NAME';
export const BROADCAST_SET_ATTENDEE_MUTE_STATUS =
  'BROADCAST_SET_ATTENDEE_MUTE_STATUS';
export const BROADCAST_SET_MULTIPLE_ATTENDEE_MUTE_STATUSES =
  'BROADCAST_SET_MULTIPLE_ATTENDEE_MUTE_STATUSES';
export const BROADCAST_SET_MULTIPLE_DESIRED_ATTENDEE_MUTE_STATUSES =
  'BROADCAST_SET_MULTIPLE_DESIRED_ATTENDEE_MUTE_STATUSES';
export const BROADCAST_TOGGLE_MULTIPLE_AGORA_ATTENDEE_MUTE_STATUSES =
  'BROADCAST_TOGGLE_MULTIPLE_AGORA_ATTENDEE_MUTE_STATUSES';
export const BROADCAST_SET_DESIRED_ATTENDEE_MUTE_STATUS =
  'BROADCAST_SET_DESIRED_ATTENDEE_MUTE_STATUS';
export const BROADCAST_SET_ATTENDEE_CONNECTION_METRICS =
  'BROADCAST_SET_ATTENDEE_CONNECTION_METRICS';
export const BROADCAST_DISMISS_ATTENDEE = 'BROADCAST_DISMISS_ATTENDEE';
export const BROADCAST_CLEAR_DISMISSED_ATTENDEE =
  'BROADCAST_CLEAR_DISMISSED_ATTENDEE';
export const BROADCAST_REMOVE_ATTENDEE_CAMERA =
  'BROADCAST_REMOVE_ATTENDEE_CAMERA';
export const BROADCAST_SET_ALL_ATTENDEES_CAMERA_STATUS =
  'BROADCAST_SET_ALL_ATTENDEES_CAMERA_STATUS';
export const BROADCAST_TOGGLE_MULTIPLE_AGORA_ATTENDEE_CAMERA_STATUSES =
  'BROADCAST_TOGGLE_MULTIPLE_AGORA_ATTENDEE_CAMERA_STATUSES';
export const BROADCAST_CREATE_STREAM_ENDPOINT =
  'BROADCAST_CREATE_STREAM_ENDPOINT';
export const BROADCAST_DELETE_STREAM_ENDPOINT =
  'BROADCAST_DELETE_STREAM_ENDPOINT';
export const BROADCAST_UPDATE_STREAM_ENDPOINT =
  'BROADCAST_UPDATE_STREAM_ENDPOINT';
export const BROADCAST_UPDATE_STREAM_REALTIME =
  'BROADCAST_UPDATE_STREAM_REALTIME';

export const BROADCAST_SYNC_ENDPOINTS = 'BROADCAST_SYNC_ENDPOINTS';
export const BROADCAST_START_STREAM = 'BROADCAST_START_STREAM';
export const BROADCAST_STOP_STREAM = 'BROADCAST_STOP_STREAM';
export const BROADCAST_START_STREAMS = 'BROADCAST_START_STREAMS';
export const BROADCAST_STOP_STREAMS = 'BROADCAST_STOP_STREAMS';

export const BROADCAST_SET_PROGRAM = 'BROADCAST_SET_PROGRAM';
export const BROADCAST_SET_SCENE_LAYOUT = 'BROADCAST_SET_SCENE_LAYOUT';
export const BROADCAST_ADD_MEDIA_SOURCE_TO_PROGRAM =
  'BROADCAST_ADD_MEDIA_SOURCE_TO_PROGRAM';

export const BROADCAST_APPROVE_ALL_KNOCKS = 'BROADCAST_APPROVE_ALL_KNOCKS';
export const BROADCAST_APPROVE_KNOCK = 'BROADCAST_APPROVE_KNOCK';
export const BROADCAST_ACCEPT_KNOCK = 'BROADCAST_ACCEPT_KNOCK';
export const BROADCAST_REJECT_KNOCK = 'BROADCAST_REJECT_KNOCK';
export const BROADCAST_DENY_KNOCK = 'BROADCAST_DENY_KNOCK';
export const BROADCAST_SET_DESIRED_KNOCK_AV_STATUS =
  'BROADCAST_SET_DESIRED_KNOCK_AV_STATUS';
export const BROADCAST_UPDATE_KNOCK = 'BROADCAST_UPDATE_KNOCK';

export const BROADCAST_CREATE_SOURCE = 'BROADCAST_CREATE_SOURCE';
export const BROADCAST_CREATE_SOURCES = 'BROADCAST_CREATE_SOURCES';
export const BROADCAST_GET_SOURCES = 'BROADCAST_GET_SOURCES';
export const BROADCAST_DELETE_SOURCE = 'BROADCAST_DELETE_SOURCE';
export const BROADCAST_DELETE_SOURCES = 'BROADCAST_DELETE_SOURCES';
export const BROADCAST_UPDATE_SOURCE = 'BROADCAST_UPDATE_SOURCE';
export const BROADCAST_UPDATE_SOURCE_THUMBNAIL =
  'BROADCAST_UPDATE_SOURCE_THUMBNAIL';
export const BROADCAST_DISCONNECT_SOURCE = 'BROADCAST_DISCONNECT_SOURCE';
export const BROADCAST_QUEUE_SOURCE_DISCONNECT =
  'BROADCAST_QUEUE_SOURCE_DISCONNECT';
export const BROADCAST_CANCEL_SOURCE_DISCONNECT =
  'BROADCAST_CANCEL_SOURCE_DISCONNECT';
export const BROADCAST_SET_SOURCE_UPLOAD_PROGRESS =
  'BROADCAST_SET_SOURCE_UPLOAD_PROGRESS';
export const BROADCAST_SET_DESIRED_ATTENDEE_CAMERA_STATUS =
  'BROADCAST_SET_DESIRED_ATTENDEE_CAMERA_STATUS';
export const BROADCAST_SET_MULTIPLE_DESIRED_ATTENDEE_CAMERA_STATUSES =
  'BROADCAST_SET_MULTIPLE_DESIRED_ATTENDEE_CAMERA_STATUSES';
export const BROADCAST_SET_ATTENDEE_CAMERA_STATUS =
  'BROADCAST_SET_ATTENDEE_CAMERA_STATUS';
export const BROADCAST_SET_ATTENDEE_MUSIC_PROFILE =
  'BROADCAST_SET_ATTENDEE_MUSIC_PROFILE';
export const PRESENTER_AUDIO_BITRATE = 'PRESENTER_AUDIO_BITRATE';
export const BROADCAST_STOP_PRESENTER_SCREEN_SHARE =
  'BROADCAST_STOP_PRESENTER_SCREEN_SHARE';
export const BROADCAST_UPDATE_CONTENT_SHARE_AUDIO_PROFILE =
  'BROADCAST_UPDATE_CONTENT_SHARE_AUDIO_PROFILE';
export const BROADCAST_CREATE_LIVE_RECORDING =
  'BROADCAST_CREATE_LIVE_RECORDING';
export const BROADCAST_DELETE_LIVE_RECORDING =
  'BROADCAST_DELETE_LIVE_RECORDING';
export const BROADCAST_UPDATE_LIVE_RECORDING =
  'BROADCAST_UPDATE_LIVE_RECORDING';
export const BROADCAST_UPDATE_RECORDING_REALTIME =
  'BROADCAST_UPDATE_RECORDING_REALTIME';
export const BROADCAST_START_RECORDING = 'BROADCAST_START_RECORDING';
export const BROADCAST_STOP_RECORDING = 'BROADCAST_STOP_RECORDING';
export const BROADCAST_START_RECORDINGS = 'BROADCAST_START_RECORDINGS';
export const BROADCAST_STOP_RECORDINGS = 'BROADCAST_STOP_RECORDINGS';
export const BROADCAST_SET_RECORDING_STARTING =
  'BROADCAST_SET_RECORDING_STARTING';
export const BROADCAST_DOWNLOAD_LIVE_RECORDING =
  'BROADCAST_DOWNLOAD_LIVE_RECORDING';
export const BROADCAST_SYNC_RECORDINGS = 'BROADCAST_SYNC_RECORDINGS';
export const BROADCAST_SYNC_LAYER_SOURCES = 'BROADCAST_SYNC_LAYER_SOURCES';
export const BROADCAST_PROGRAM_SOURCES_SYNC = 'BROADCAST_PROGRAM_SOURCES_SYNC';
export const BROADCAST_GET_ENDPOINTS = 'BROADCAST_GET_ENDPOINTS';
export const BROADCAST_GET_RECORDINGS = 'BROADCAST_GET_RECORDINGS';
export const BROADCAST_INITIALIZING_SOURCE = 'BROADCAST_INITIALIZING_SOURCE';
export const BROADCAST_UPDATE_PROGRAM_INITIALIZING_STATE =
  'BROADCAST_UPDATE_PROGRAM_INITIALIZING_STATE';

//Sidebar
export const SIDEBAR_SEARCH_CONTENT = 'SIDEBAR_SEARCH_CONTENT';
export const CLEAR_SIDEBAR_SEARCH_CONTENT = 'CLEAR_SIDEBAR_SEARCH_CONTENT';

// layer sources
export const BROADCAST_CREATE_BACKGROUND = 'BROADCAST_CREATE_BACKGROUND';
export const BROADCAST_DELETE_BACKGROUND = 'BROADCAST_DELETE_BACKGROUND';
export const BROADCAST_UPLOAD_BACKGROUND = 'BROADCAST_UPLOAD_BACKGROUND';
export const BROADCAST_BACKGROUND_SCAN = 'BROADCAST_BACKGROUND_SCAN';
export const BROADCAST_CREATE_OVERLAY = 'BROADCAST_CREATE_OVERLAY';
export const BROADCAST_UPLOAD_OVERLAY = 'BROADCAST_UPLOAD_OVERLAY';
export const BROADCAST_UPDATE_OVERLAY_STATE = 'BROADCAST_UPDATE_OVERLAY_STATE';
export const BROADCAST_DELETE_OVERLAY = 'BROADCAST_DELETE_OVERLAY';
export const BROADCAST_GET_CONFIG = 'BROADCAST_GET_CONFIG';
export const BROADCAST_UPDATE_OVERLAY_POSITION =
  'BROADCAST_UPDATE_OVERLAY_POSITION';
export const BROADCAST_UPDATE_BACKGROUND_POSITION =
  'BROADCAST_UPDATE_BACKGROUND_POSITION';
export const BROADCAST_TOGGLE_OVERLAY_HIDDEN =
  'BROADCAST_TOGGLE_OVERLAY_HIDDEN';
export const BROADCAST_TOGGLE_OVERLAY_STATUS =
  'BROADCAST_TOGGLE_OVERLAY_STATUS';
export const BROADCAST_TOGGLE_BACKGROUND_HIDDEN =
  'BROADCAST_TOGGLE_BACKGROUND_HIDDEN';
export const BROADCAST_TOGGLE_BACKGROUND_STATUS =
  'BROADCAST_TOGGLE_BACKGROUND_STATUS';
export const BROADCAST_UPDATE_SCENE_LAYERS = 'BROADCAST_UPDATE_SCENE_LAYERS';
export const BROADCAST_SET_SCENE_LAYERS = 'BROADCAST_SET_SCENE_LAYERS';
export const BROADCAST_SYNC_SCENE_LAYERS = 'BROADCAST_SYNC_SCENE_LAYERS';
export const BROADCAST_UPDATE_SETTINGS = 'BROADCAST_UPDATE_SETTINGS';

// banners & banner templates
export const BROADCAST_GET_GLOBAL_BANNER_TEMPLATES =
  'BROADCAST_GET_GLOBAL_BANNER_TEMPLATES';
export const BROADCAST_SYNC_BANNERS = 'BROADCAST_SYNC_BANNERS';
export const BROADCAST_DELETE_BANNER = 'BROADCAST_DELETE_BANNER';
export const BROADCAST_UPDATE_BANNER = 'BROADCAST_UPDATE_BANNER';
export const BROADCAST_CREATE_BANNER = 'BROADCAST_CREATE_BANNER';
export const BROADCAST_DUPLICATE_BANNER = 'BROADCAST_DUPLICATE_BANNER';
export const BROADCAST_SYNC_BANNERS_STATUS = 'BROADCAST_SYNC_BANNERS_STATUS';
export const BROADCAST_TOGGLE_BANNER_HIDDEN = 'BROADCAST_TOGGLE_BANNER_HIDDEN';

//Media Player
export const MEDIA_PLAYER_LOOP_MEDIA = 'MEDIA_PLAYER_LOOP_MEDIA';
export const SET_MEDIA_PLAYER_SETTINGS = 'SET_MEDIA_PLAYER_SETTINGS';
export const UPDATE_MEDIA_PLAYER_SETTINGS = 'UPDATE_MEDIA_PLAYER_SETTINGS';
export const MEDIA_PLAYER_MUTE_MEDIA = 'MEDIA_PLAYER_MUTE_MEDIA';
export const MEDIA_PLAYER_SET_DURATION = 'MEDIA_PLAYER_SET_DURATION';

// Source Tabs
export const BROACAST_SOURCES_SELECT_TAB = 'BROACAST_SOURCES_SELECT_TAB';

// Stage Sources
export const BROADCAST_TOGGLE_STAGE_SOURCE = 'BROADCAST_TOGGLE_STAGE_SOURCE';
export const BROADCAST_QUEUE_STAGE_LAYOUT = 'BROADCAST_QUEUE_STAGE_LAYOUT';
export const BROADCAST_CLEAR_STAGED_SOURCES = 'BROADCAST_CLEAR_STAGED_SOURCES';

// Templates Sources
export const BROADCAST_SAVE_TEMPLATE = 'BROADCAST_SAVE_TEMPLATE';

// Presenter Settings
export const PRESENTER_SETTINGS_SOURCE = 'PRESENTER_SETTINGS_SOURCE';
export const BROADCAST_UPDATE_PRESENTER_SETTINGS =
  'BROADCAST_UPDATE_PRESENTER_SETTINGS';

//Reorder sources
export const BROADCAST_REORDER_SOURCES = 'BROADCAST_REORDER_SOURCES';
export const BROADCAST_DRAG_SOURCE = 'BROADCAST_DRAG_SOURCE';
export const BROADCAST_EDIT_SOURCES_ORDER = 'BROADCAST_EDIT_SOURCES_ORDER';
export const BROACAST_TEMPLATES_SELECT_TAB = 'BROACAST_TEMPLATES_SELECT_TAB';

// Interactive Streams
export const SET_STOP_STREAM_CONFIRMATION = 'SET_STOP_STREAM_CONFIRMATION';

export const MUTE_MEETING_AUDIO = 'MUTE_MEETING_AUDIO';

// Sync server time across subscribers
export const BROADCAST_GET_SERVER_TIME = 'BROADCAST_GET_SERVER_TIME';
export const BROADCAST_SET_SERVER_TIME_DELTA =
  'BROADCAST_SET_SERVER_TIME_DELTA';

// Scene action types
export const BROADCAST_SCENE_SYNC = 'BROADCAST_SCENE_SYNC';
export const BROADCAST_SCENE_CREATE = 'BROADCAST_SCENE_CREATE';
export const BROADCAST_SCENE_UPDATE = 'BROADCAST_SCENE_UPDATE';
export const BROADCAST_SCENES_UPDATE = 'BROADCAST_SCENES_UPDATE';
export const BROADCAST_SCENE_DELETE = 'BROADCAST_SCENE_DELETE';
export const BROADCAST_SCENE_TAKE_LIVE = 'BROADCAST_SCENE_TAKE_LIVE';
export const BROADCAST_SET_SELECTED_SCENE = 'BROADCAST_SET_SELECTED_SCENE';
export const BROADCAST_SCENE_ORDER_UPDATE = 'BROADCAST_SCENE_ORDER_UPDATE';
export const BROADCAST_UPDATE_SCENE_PREVIEW = 'BROADCAST_UPDATE_SCENE_PREVIEW';
export const BROADCAST_UPDATE_SCENE_SET_SOURCE_AS_PLACEHOLDER =
  'BROADCAST_UPDATE_SCENE_SET_SOURCE_AS_PLACEHOLDER';
export const BROADCAST_UPDATE_SCENE_DELETE_SOURCE_FROM_SCENE =
  'BROADCAST_UPDATE_SCENE_DELETE_SOURCE_FROM_SCENE';
export const BROADCAST_REPLACE_SOURCE_FROM_SCENE =
  'BROADCAST_REPLACE_SOURCE_FROM_SCENE';
export const BROADCAST_SET_SCENES_WITH_SOURCE =
  'BROADCAST_SET_SCENES_WITH_SOURCE';
export const BROADCAST_GET_SCENES = 'BROADCAST_GET_SCENES';
export const BROADCAST_SCENE_DUPLICATE = 'BROADCAST_SCENE_DUPLICATE';
export const UPDATE_SCENE_SPINNER = 'UPDATE_SCENE_SPINNER';

// delete attendee from meeting
export const BROADCAST_DELETE_MEETING_ATTENDEE =
  'BROADCAST_DELETE_MEETING_ATTENDEE';

export const BROADCAST_SET_ATTENDEE_NETWORK_HEALTH =
  'BROADCAST_SET_ATTENDEE_NETWORK_HEALTH';

export const BROADCAST_SET_ATTENDEE_RECEIVED_FRAME =
  'BROADCAST_SET_ATTENDEE_RECEIVED_FRAME';

// Feature flags
export const SET_BROADCAST_FEATURE_FLAGS = 'SET_BROADCAST_FEATURE_FLAGS';

// Sync broadcast settings
export const SYNC_BROADCAST_SETTINGS = 'SYNC_BROADCAST_SETTINGS';

// Toggle notification list
export const TOGGLE_NOTIFICATION_LIST = 'TOGGLE_NOTIFICATION_LIST';

export const SET_ATTENDEE_DETAILS = 'SET_ATTENDEE_DETAILS';

export const BROADCAST_CREATE_SANDBOX_MEETING =
  'BROADCAST_CREATE_SANDBOX_MEETING';

// Update broadcast director request
export const BROADCAST_UPDATE_REQUEST = 'BROADCAST_UPDATE_REQUEST';

// Add source to knock
export const BROADCAST_SOURCE_TO_KNOCK = 'BROADCAST_SOURCE_TO_KNOCK';

// Logs
export const BROADCAST_CREATE_LOG = 'BROADCAST_CREATE_LOG';

export const BROADCAST_SET_DIRECTOR_MEETING_VALUE =
  'BROADCAST_SET_DIRECTOR_MEETING_VALUE';

export const UNASSIGN_DIRECTOR_FROM_SOURCE = 'UNASSIGN_DIRECTOR_FROM_SOURCE';
export const BROADCAST_SET_SESSION_ID = 'BROADCAST_SET_SESSION_ID';

export const BROADCAST_RELOAD_BANNER = 'BROADCAST_RELOAD_BANNER';

/** Update Broadcast source tanscoding status */
export const BROADCAST_SOURCES_TRANSCODING_STATUS =
  'BROADCAST_SOURCES_TRANSCODING_STATUS';

/**  */
export const BROADCAST_MEETING_FAILED = 'BROADCAST_MEETING_FAILED';

/** Get branding settings */
export const GET_BRANDING_SETTINGS = 'GET_BRANDING_SETTINGS';
export const LOGOUT_USER = 'LOGOUT_USER';
